export const iconFontAwesomeMapsRocket = (
	<i className="fa-solid fa-rocket"></i>
);
